// Unified favorites - a single store that holds three kinds of item:
//   { type:"site",  url, title }            ← the toolbar ★ (opens proxied)
//   { type:"book",  url, name, cover }       ← a game from the library
//   { type:"app",   url, name, category }    ← a Worksheets web-app
// All three surface together in the Favorites view, so favoriting works as one
// ecosystem. Persisted to localStorage and live across the app + settings.
import { readJSON, writeJSON, subscribe as subStore } from "../shared/store.js";
import { FAVORITES_KEY, BOOKMARKS_KEY } from "../shared/settings-schema.js";

// One-time migration: fold legacy site bookmarks into favorites.
(function migrate() {
	if (readJSON(FAVORITES_KEY, null) != null) return;
	const old = readJSON(BOOKMARKS_KEY, null);
	if (Array.isArray(old) && old.length) {
		writeJSON(FAVORITES_KEY, old.map((b) => ({ type: "site", url: b.url, title: b.title, ts: b.ts || Date.now() })));
	}
})();

export const keyOf = (it) => (it && it.type ? it.type : "site") + "|" + ((it && (it.url || it.id)) || "");

export function list() { const v = readJSON(FAVORITES_KEY, []); return Array.isArray(v) ? v : []; }

export function has(it) { const k = keyOf(it); return list().some((x) => keyOf(x) === k); }

export function add(it) {
	if (!it || !(it.url || it.id)) return;
	const k = keyOf(it);
	const items = list().filter((x) => keyOf(x) !== k);
	items.unshift({ ...it, ts: Date.now() });
	writeJSON(FAVORITES_KEY, items);
}

export function remove(it) { const k = keyOf(it); writeJSON(FAVORITES_KEY, list().filter((x) => keyOf(x) !== k)); }

// Returns the new state (true = now favorited).
export function toggle(it) { if (has(it)) { remove(it); return false; } add(it); return true; }

export function clear() { writeJSON(FAVORITES_KEY, []); }

export function subscribe(fn) { return subStore(FAVORITES_KEY, fn); }
